import { FormattedMessage } from 'react-intl'
import {RiskMatrixListToolbar} from './RiskMatrixListToolbar'

const RiskMatrixListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      <h2 className='fw-bolder'>{<FormattedMessage id ="RISK.MATRIX.LIST"/>}</h2>
      {/* <ParametersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {<RiskMatrixListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {RiskMatrixListHeader}
